import { useMemo } from 'react';
import useSWR from 'swr';
import { useHandleError } from '@/hooks/useHandleError';
import { apiFetch } from '@/lib/api/apiClient';
import { HubNewsItem, HubNewsResponse, HubNewsTagCategoryItem } from '@/types/hubs';

export const useHubNewsList = () => {
    const { handleError, clearError } = useHandleError();

    const fetcher = async (url: string) => {
        clearError();
        try {
            return await apiFetch(url, { method: 'GET' });
        } catch (error: unknown) {
            handleError(error);
            throw error;
        }
    };

    const { data, error, isLoading, mutate } = useSWR<HubNewsResponse>('/hubs/news', fetcher);

    const hubNewsList: HubNewsItem[] = useMemo(
        () =>
            (data?.hub_news_list ?? []).map((hubNews) => ({
                ...hubNews,
                hub_index: String(hubNews.hub_index),
                hub_news_index: String(hubNews.hub_news_index),
            })),
        [data],
    );

    const tagCategoryList: HubNewsTagCategoryItem[] = useMemo(() => data?.tag_category_list ?? [], [data]);

    return {
        hubNewsList,
        tagCategoryList,
        totalCount: data?.count ?? 0,
        isLoading,
        mutate,
        isError: !!error,
    };
};
